import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule } from '@spartacus/core';
import { IconModule, KeyboardFocusModule } from '@spartacus/storefront';

import { KnBrActiveFacetComponent } from './kn-br-active-facet.component';
import { KnBrCustomPipesModule } from 'src/app/shared/pipe/kn-br-custom-pipes/kn-br-custom-pipes.module';

@NgModule({
    imports: [CommonModule, RouterModule, I18nModule, IconModule, KeyboardFocusModule, KnBrCustomPipesModule, KnBrActiveFacetComponent],
    exports: [KnBrActiveFacetComponent],
})
export class KnBrActiveFacetModule {}
